import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as UserStructureGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/general";
import { Route as UserStructureStructurePage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/structure";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/"
)({
    component: UserStructureDetailPage,
    staticData: {
        permissions: [
            PermissionEnum.ToolStructureUserGeneral,
            PermissionEnum.ToolStructureUserStructure,
        ],
        showInSideMenu: false,
        label: "pages.tool.structure.user.detail.title",
        redirects: [UserStructureGeneralPage, UserStructureStructurePage],
        defaultRedirect: UserStructureGeneralPage,
    },
});

function UserStructureDetailPage() {
    return <RedirectPage />;
}
